<template>
	<div class="introduce-list">
		<div class="introduce">
			<div class="introduce-img">
				<img class="avatar" :src="item.photo || require('@/assets/images/avatar_default.png')" alt="" />
			</div>

			<div class="introduce-info">
				<p class="introduce-info-name text-overflow">{{ item.name }}</p>
				<div class="introduce-info-desc text-overflow" v-if="item.text">
					{{ item.text }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		item: {
			type: Object,
			default() {
				return {};
			}
		}
	}
};
</script>

<style lang="less" scoped>
.introduce {
	display: flex;
	width: 100%;
	box-sizing: border-box;
	height: 53px;
	&-img {
		margin: auto 0;
		margin-right: 12px;
		.avatar {
			width: 53px;
			height: 53px;
			border-radius: 50%;
			object-fit: cover;
		}
	}

	&-info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		overflow: hidden;

		&-name {
			max-width: 80%;
			color: var(--t-emphasis-color, #1d2129);
			 
			font-size: 16px;
			 
			font-weight: 500;
			line-height: 140%; /* 22.4px */
		}
		&-desc {
			max-width: 80%;

			margin-top: 12px;
			color: var(--t-secondary-color, #4e5969);
			 
			font-size: 14px;
			 
			font-weight: 400;
			line-height: 16px; /* 114.286% */
		}
	}
}
</style>
